module.exports = __webpack_public_path__ + "img/ambulance.289f8eef.png";